import { render, staticRenderFns } from "./AsideMenu.vue?vue&type=template&id=62f4fb90&scoped=true&"
import script from "./AsideMenu.vue?vue&type=script&lang=ts&"
export * from "./AsideMenu.vue?vue&type=script&lang=ts&"
import style0 from "./AsideMenu.vue?vue&type=style&index=0&id=62f4fb90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f4fb90",
  null
  
)

export default component.exports